var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart card"},[_c('div',{staticClass:"card-body"},[_c('canvas',{class:_vm.classes,attrs:{"id":_vm.id,"aria-label":"chart","role":"img"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }